var map = {
	"./bBox-green.png": "eb78",
	"./bBox-orange.png": "523f",
	"./background.png": "a74e",
	"./bell.png": "b17c",
	"./billing-green.png": "f3ae",
	"./billing-orange.png": "d615",
	"./chat-green.png": "61b4",
	"./chat-orange.png": "dfe2",
	"./express-box.png": "31c6",
	"./goodsList.png": "65b3",
	"./icon1.png": "91fa",
	"./icon2.png": "2653",
	"./icon3.png": "7094",
	"./icon4.png": "a8a2",
	"./line.png": "c700",
	"./logo.png": "013a",
	"./money.png": "200a",
	"./phone-green.png": "26e5",
	"./phone-orange.png": "243a",
	"./sBox-green.png": "2016",
	"./sBox-orange.png": "d13f",
	"./user-add-green.png": "5cc8",
	"./user-add-orange.png": "2671",
	"./user-count-green.png": "cbdc",
	"./user-count-orange.png": "9fb0",
	"./user.png": "31a5",
	"./yue-green.png": "e760",
	"./yue-orange.png": "fc43"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b6a";